import type { TaskStep } from "@/services/api/data-hub/types";

import { deriveItemGroupProgress, type ItemGroupTaskProgress } from "./itemGroupTaskProgress";

const CLASSIFY_STEP_LABEL = "Classify documents";
const RE_CLASSIFY_STEP_LABEL = "Re-classify documents";

export type ClassificationTaskProgress = ItemGroupTaskProgress;

function classificationLabel({ processedCount, total, failed }: { processedCount: number; total: number; failed: number }): string {
  const failedSuffix = failed > 0 ? `, ${failed} failed` : "";
  return `Classifying: ${processedCount}/${total}${failedSuffix}`;
}

/** Derive document classification counts from runner task steps (classify / re-classify item groups). */
export function deriveClassificationTaskProgress(
  steps: TaskStep[],
  _overallProgress: number,
): ClassificationTaskProgress | null {
  return (
    deriveItemGroupProgress(steps, CLASSIFY_STEP_LABEL, classificationLabel) ??
    deriveItemGroupProgress(steps, RE_CLASSIFY_STEP_LABEL, classificationLabel)
  );
}
